<template>
  <div class="squadra-tavolo" :class="squadraClass">
    <div class="cyan haScelto white--text" v-if="haScelto_">Ha scelto</div>
    <div class="cyan staScegliendo white--text" v-if="staScegliendo_">
      Sta scegliendo
    </div>

    <span class="offerta" v-if="isVincente && mostraVincente">{{
      offerta
    }}</span>
    <v-menu eager absolute>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <div class="content">
            <div class="left-part">
              <img :src="pic" v-if="pic" />
              <div v-if="isSpeaker_" class="countdown">
                <div>{{ timeLeft != null ? timeLeft : 0 }}</div>
              </div>
            </div>

            <div class="details">
              <div class="nome">{{ squadra_.name }}</div>

              <ruoli-completati :id_squadra="id"></ruoli-completati>

              <div class="crediti-wrapper">
                <div class="rimanenti">
                  <animate-number :number="crediti"></animate-number>
                </div>

                <div class="offerta-max">
                  <div class="label">Max</div>
                  <animate-number :number="maxOfferta"></animate-number>
                </div>
              </div>
            </div>
            <div class="stato" :class="presenceClass"></div>
          </div>
        </div>
      </template>
      <v-list dense>
        <v-list-item @click="mostraRosa">
          <v-list-item-title
            ><v-icon small left class="text--text">admin_panel_settings</v-icon
            >Mostra rosa</v-list-item-title
          >
        </v-list-item>
        <v-list-item :disabled="forzaPassoDisabled" @click="forzaPasso">
          <v-list-item-title class="error--text"
            ><v-icon small left class="error--text">airline_stops</v-icon>Forza
            'Passo'</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          :disabled="setActiveDisabled"
          v-if="squadra_.active == 1"
          @click="setActive(0)"
        >
          <v-list-item-title class="error--text"
            ><v-icon small left class="error--text">person_remove</v-icon
            >Escludi temporaneamente</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          :disabled="setActiveDisabled"
          v-if="squadra_.active == 0"
          @click="setActive(1)"
        >
          <v-list-item-title
            ><v-icon small left>person_add</v-icon>Riammetti
            all'asta</v-list-item-title
          >
        </v-list-item>

        <v-list-item
          v-if="Config.STANDALONE"
          @click="promptEditCreditiSquadra(id)"
        >
          <v-list-item-title
            ><v-icon small left class="text--text">mode_edit</v-icon>Modifica
            crediti</v-list-item-title
          >
        </v-list-item>

        <v-list-item @click="showAstaOrder">
          <v-list-item-title
            ><v-icon left small class="text--text"
              >settings_backup_restore</v-icon
            >
            Ordine partecipanti</v-list-item-title
          >
        </v-list-item>

        <v-list-item @click="promptChangeAdmin">
          <v-list-item-title
            ><v-icon left small class="text--text">engineering</v-icon>
              <span v-if="adminUid == squadra_.id"
                >Rimuovi da Amministratore</span
              >
              <span v-else>Rendi Amministratore</span>
              <small class="d-inline-block error white--text ml-1 px-1 rounded">NEW</small>
          </v-list-item-title>
        </v-list-item>

        <v-divider class="mb-2"></v-divider>

        <v-list-item>
          <v-list-item-title>Layout</v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-btn-toggle
            dense
            class="ml-2"
            v-model="tavoloLayoutModel"
            mandatory
            borderless
          >
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.TAVOLO_LAYOUT.CERCHIO"
              @click.stop
            >
              <v-icon :class="colorSpeedDial" small>lens</v-icon>
            </v-btn>
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.TAVOLO_LAYOUT.GRIGLIA"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">view_module</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-list-item-title></v-list-item-title>
        </v-list-item>

        <v-list-item
          v-show="tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO"
        >
          <v-btn-toggle
            dense
            class="progressive-sizes ml-2"
            v-model="tavoloSizeModel"
            mandatory
            borderless
          >
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.TAVOLO_SIZE.SMALL"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">lens</v-icon>
            </v-btn>
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.TAVOLO_SIZE.MEDIUM"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">lens</v-icon>
            </v-btn>
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.TAVOLO_SIZE.LARGE"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">lens</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-list-item-title></v-list-item-title>
        </v-list-item>

        <v-list-item>
          <v-btn-toggle
            dense
            class="progressive-sizes ml-2"
            v-model="squadreSizeModel"
            mandatory
            borderless
          >
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.SQUADRE_SIZE.SMALL"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">account_box</v-icon>
            </v-btn>
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.SQUADRE_SIZE.MEDIUM"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">account_box</v-icon>
            </v-btn>
            <v-btn
              :class="bgSpeedDial"
              :value="Constants.SQUADRE_SIZE.LARGE"
              @click.stop
            >
              <v-icon :class="colorSpeedDial">account_box</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-list-item-title></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";
import Vuex from "vuex";
import AnimateNumber from "./AnimateNumber.vue";
import RuoliCompletati from "./RuoliCompletati";
import toast from "../../js/toast";

export default {
  name: "squadra-tavolo",
  mixins: [mixins, toast],
  components: { AnimateNumber, RuoliCompletati },
  props: {
    id: {
      type: String,
      required: true,
      default: null,
    },
    showArrow: {
      type: Boolean,
    },
    // clicked: {
    //   type: Function,
    //   default: function () {},
    // },
  },
  methods: {
    showAstaOrder() {
      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      db.emit("showAstaOrder");
    },
    promptChangeAdmin() {
      db.emit("promptChangeAdmin");
    },
    mostraRosa() {
      this.$store.dispatch("setSquadraSelected", this.id);
      this.$store.dispatch("switchPlanOrRose", "rose");
      db.emit("showRoseOrPlan");
    },
    forzaPasso() {
      if (this.forzaPassoDisabled) {
        return;
      }
      Swal.fire({
        html:
          'Vuoi forzare un passo per <span class="bold">' +
          this.squadra_.name +
          "</span>?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.astaLogPassoForzato(this.id) // devo farlo prima per essere sicuro avvenga prima dell'assegnazione
            .then(db.setPasso(this.id, this.mode_poker))
            .catch((err) => {
              console.error(err);
              this.errorToast("Errore", "Operazione non consentita!");
            });
        }
      });
    },
    setActive(active) {
      if (this.setActiveDisabled) {
        return;
      }

      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }

      // STO DISATTIVANDO ADMIN
      // if (this.adminUid == this.id && active == 0) {
      //   Swal.fire({
      //     title: "Attenzione",
      //     text: "Sei l'amministratore di lega, dovrai comunque rimanere online per consentire agli altri partecipanti di proseguire l'asta. Vuoi continuare?",
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonText: "Si",
      //     cancelButtonText: "No",
      //   }).then((result) => {
      //     if (result.isConfirmed == true) {
      //       db.setActiveSquadra(this.id, active).then(() => {
      //         db.setAstaMsg(
      //           Constants.ASTA_MSG.ANNULLA,
      //           "L'amministratore di lega si è escluso dall'asta. IMPORTANTE: Dovrà comunque rimanere online per consentire agli altri partecipanti di proseguire l'asta"
      //         );
      //       });
      //     }
      //   });
      //   return;
      // }

      db.setActiveSquadra(this.id, active).then(() => {
        if (active == 1) {
          this.astaLogRiammissioneAsta(this.id);
        } else {
          if (this.adminUid == this.id) {
            this.astaLogEsclusioneAstaAdmin(this.id);
            db.emit("swalAdminEscluso", false);
          } else {
            this.astaLogEsclusioneAsta(this.id);
          }
        }
      });
    },
  },
  computed: {
    timeLeft() {
      return this.asta_round.speakerTimeLeft;
    },
    squadra_() {
      return this.asta_squadre[this.id];
    },
    maxOfferta() {
      return this.squadra_.max_offerta;
    },
    forzaPassoDisabled() {
      return (
        !this.admin ||
        !this.calciatoreInAsta ||
        this.not_running ||
        this.mode_assegna ||
        this.squadra_.active === 0 ||
        (this.mode_poker && this.asta_round.speaker !== this.id) ||
        this.offerta == Constants.OFFERTA.PASSO ||
        this.adminUid == this.id
      );
    },
    setActiveDisabled() {
      return !this.admin;
    },
    presence() {
      return this.asta_online[this.id];
    },
    presenceClass() {
      return this.getPresenceClass(this.presence);
      // return {
      //   online: this.presence == Constants.PRESENCE_STATES.ONLINE,
      //   idle:
      //     this.presence == Constants.PRESENCE_STATES.IDLE ||
      //     this.presence == Constants.PRESENCE_STATES.AWAY ||
      //     this.presence == Constants.PRESENCE_STATES.PENDING,
      //   offline:
      //     this.presence == Constants.PRESENCE_STATES.RESET ||
      //     this.presence == Constants.PRESENCE_STATES.OFFLINE ||
      //     this.presence == "" ||
      //     this.presence == null,
      // };
    },
    squadraClass: function () {
      return {
        showArrow: this.showArrow,
        [this.squadreSize]: true,
        [this.squadreOrientation]: true,
        vincente: this.isVincente,
        isSpeaker: this.isSpeaker_,
        haPassato:
          ((this.mode_poker || this.mode_selvaggia) &&
            this.offerta == Constants.OFFERTA.PASSO) ||
          !this.squadra_.active,
      };
    },
    staScegliendo_() {
      return this.staScegliendo(this.id);
    },
    haScelto_() {
      return this.haScelto(this.id);
    },
    isSpeaker_() {
      return this.isSpeaker(this.id);
    },
    isVincente() {
      return (
        this.offerta &&
        this.offerta > 0 &&
        this.migliore_offerta.vincitore == this.id
      );
    },
    mostraVincente() {
      return this.mode_poker || this.mode_selvaggia;
    },
    offerta: function () {
      return this.asta_round.offerte ? this.asta_round.offerte[this.id] : -1;
    },
    crediti: function () {
      return this.squadra_.crediti;
    },
    pic: function () {
      return this.squadra_.pic ? this.squadra_.pic : null;
    },
    migliore_offerta_val: function () {
      return this.migliore_offerta.offerta
        ? this.migliore_offerta.offerta
        : null;
    },
    squadreSizeModel: {
      get() {
        return this.squadreSize;
      },
      set(value) {
        this.$store.dispatch("setSquadreSize", value);
      },
    },
    tavoloSizeModel: {
      get() {
        return this.tavoloSize;
      },
      set(value) {
        this.$store.dispatch("setTavoloSize", value);
      },
    },
    tavoloLayoutModel: {
      get() {
        return this.tavoloLayout;
      },
      set(value) {
        // check
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          let nSquadre = _.size(this.asta_squadre);
          let limit = Constants.LIMIT_SQUADRE_LAYOUT_CERCHIO;
          if (nSquadre > limit) {
            Swal.fire({
              icon: "info",
              title: "Suggerimento",
              text:
                "In leghe con più di " +
                limit +
                ' squadre è preferibile la visualizzazione a "griglia" e non a "tavolo rotondo" per evitare sovrapposizioni tra le squadre intorno al tavolo',
              confirmButtonText: "Ok, ho capito",
            });
          }
        }
        this.$store.dispatch("setTavoloLayout", value);
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          this.$store.dispatch("setSquadreSize", Constants.SQUADRE_SIZE.SMALL);
        }
      },
    },
    bgSpeedDial() {
      return "white";
    },
    colorSpeedDial() {
      return "text--text";
    },
    ...Vuex.mapGetters([
      "asta_squadre",
      "asta_info",
      "asta_round",
      "asta_online",
      "migliore_offerta",
      "squadreSize",
      "tavoloLayout",
      "squadreOrientation",
      "useSound",
      "is_mobile",
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
// .speeddial {
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
.v-btn-toggle {
  margin: 0 0px 6px 0;
  flex-direction: row-reverse;
  background: transparent;

  > .v-btn.v-btn:first-child {
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  > .v-btn.v-btn:last-child {
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .v-btn {
    margin: 0;
    opacity: 1;
    background: var(--v-navy-base);
    &.v-item--active {
      color: transparent;
      // background: var(--v-navy-base) !important;
      box-shadow: 0px 5px 0px -3px var(--v-navy-base);
      i {
        // color: white !important;
      }
    }
  }
  &.progressive-sizes {
    .v-btn {
      &:first-child i {
        font-size: 12px;
      }

      i {
        font-size: 20px;
      }

      &:last-child i {
        font-size: 28px;
      }
    }
  }
}
// }
.squadra-tavolo {
  // box-shadow: 0 13px 6px -10px rgb(0 0 0 / 49%);
  background: transparent;
  position: relative;
  .haScelto,
  .staScegliendo {
    position: absolute;
    z-index: 2;
    border-radius: 100px;
    padding: 0px 5px;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .staScegliendo {
    min-width: 70px;
  }
  .haScelto {
    min-width: 50px;
  }
  &.showArrow:after {
    content: "";
    position: absolute;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-color: transparent var(--v-navy-base);
    display: block;
    width: 0;
    z-index: 1;
    margin-top: -5px;
    right: -5px;
    top: 50%;
  }
  &.isSpeaker .content {
    animation: pulse 1.25s infinite;
  }

  &.haPassato {
    background: white;
    box-shadow: none;
    border-radius: 10px;
    .content {
      opacity: 0.3;
      // background-color: white;
      // color: var(--v-navy-base);
    }
  }
  &.vincente {
    z-index: 2 !important;
    .offerta {
      animation: vanishIn 0.5s;
    }
  }

  .content {
    color: white;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--v-navy-darken2);
    position: relative;
    overflow: hidden;
    .stato {
      position: absolute;
      top: 4px;
      right: 4px;
    }
  }

  // horizontal
  &.horizontal {
    .content {
      display: flex;
      // clip-path: polygon(
      //   0 0px,
      //   0px 0px,
      //   0px 0,
      //   100% 0,
      //   100% calc(100% - 5px),
      //   calc(100% - 0px) calc(100% - 5px),
      //   calc(100% - 8px) 100%,
      //   0 100%
      // );
    }
    &.small {
      margin: 2px;
      .content {
        height: 50px;
        width: 88px;
      }
      .nome {
        font-size: 8px;
        max-width: 60px;
      }
      .Ruolo {
        width: 13px;
        height: 13px;
        min-width: 13px;
      }
      .crediti-wrapper {
        font-size: 9px;
      }
      .haScelto,
      .staScegliendo {
        font-size: 9px;
        top: -4px;
      }
      .offerta {
        // width: 29px;
        // height: 22px;
      }
      .left-part {
        width: 30px;
        img {
          width: 53px;
          left: -11px;
        }
      }
    }
    &.medium {
      margin: 4px;
      .content {
        height: 60px;
        width: 120px;
      }
      .nome {
        font-size: 9px;
        max-width: 80px;
        padding-top: 5px;
      }
      .Ruolo {
        width: 13px;
        height: 13px;
        min-width: 13px;
      }
      .crediti-wrapper {
        font-size: 11px;
      }
      .haScelto,
      .staScegliendo {
        font-size: 9px;
        top: -3px;
      }
      .offerta {
        // width: 40px;
        // height: 26px;
      }
      .left-part {
        width: 40px;
        img {
          width: 62px;
          left: -11px;
        }
      }
    }
    &.large {
      margin: 5px;
      .content {
        height: 70px;
        width: 140px;
      }
      .nome {
        font-size: 12px;
        max-width: 85px;
        padding-top: 7px;
      }
      .Ruolo {
        width: 13px;
        height: 13px;
        min-width: 13px;
      }
      .crediti-wrapper {
        font-size: 12px;
      }
      .haScelto,
      .staScegliendo {
        font-size: 11px;
        top: -3px;
        min-width: 80px;
      }
      .offerta {
        // width: 55px;
        // height: 27px;
      }
      .left-part {
        width: 55px;
        img {
          width: 70px;
          left: -7px;
        }
      }
    }
  }

  // &.small.vertical {
  //   height: 65px;
  //   width: 30px;
  // }
  // &.medium.vertical {
  //   height: 75px;
  //   width: 40px;
  // }
  // &.large.vertical {
  //   height: 85px;
  //   width: 50px;
  // }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1; // prende tutto il rimanente della width
  }

  .nome {
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    word-wrap: break-word;
    padding: 0px 11px 0 3px;
    text-align: center;
  }

  .left-part {
    position: relative;
    overflow: hidden;
    border-radius: 3px 0 0 3px;
    img {
      position: absolute;
      top: 0;
    }
    .countdown {
      position: absolute;
      width: 100%;
      bottom: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        background: rgb(48 63 70);
        border-radius: 4px;
        padding: 0 2px;
        font-size: 9px;
        min-width: 20px;
      }
    }
  }
  .crediti-wrapper {
    background: rgb(0 0 0 / 30%);
    display: flex;
    align-items: center;
    padding: 4px 2px;
    font-size: 9px;
    gap: 5px;
    justify-content: center;
    .rimanenti {
      color: #ffeb3b;
      font-weight: bold;
    }
    .offerta-max {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      color: white;
    }
  }

  .offerta {
    // position: absolute;
    // left: 0;
    // width: 20px;
    // height: 20px;
    // bottom: 0;
    // border-radius: 0px;
    // width: 30px;
    // height: 22px;
    // border: none;
    position: absolute;
    right: -10px;
    top: -10px;
    z-index: 2;

    width: 25px;
    height: 25px;
    min-width: 25px;
  }
}

.menu-squadra {
  position: absolute;
  right: 0px;
  bottom: -18px;
}

.menu-squadra-btn {
  margin: 0 !important;
  width: 15px !important;
}
</style>
